export function normalizeInternalRedirect(value) {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== "string") return null;

  const next = raw.trim();
  if (!next || !next.startsWith("/") || next.startsWith("//")) {
    return null;
  }
  return next;
}

export function signinRedirectForRoute(route) {
  return {
    path: "/signin",
    query: {
      next: (route && (route.fullPath || route.path)) || "/home",
    },
  };
}

export function redirectLocationFromNext(next, routeQuery = {}, routeHash = "") {
  const target = normalizeInternalRedirect(next);
  if (!target) return null;

  // If next already carries its own query/hash, use it as the source of truth.
  // This preserves deep links like /banking?refund_payout_token=...
  if (target.includes("?") || target.includes("#")) {
    return target;
  }

  // Backward compatibility for sign-in pages created by the old guard as
  // /signin?next=/banking&refund_payout_token=...
  const query = { ...(routeQuery || {}) };
  delete query.next;
  return {
    path: target,
    query,
    hash: routeHash || undefined,
  };
}
